import { useState } from "react";

import { CLOUD_PROJECT_LIST, CLOUD_STATE, CLOUD_USER, getCloudData, getCloudProjectList, getCloudUser } from "../features/cloudstorage/cloud";
import { getDomainCfg, store } from "../core/state";
import { DATA_LIST, EDITOR_VIEW_NAME } from "../core/constants";
import { listData } from "../features/cloudstorage/wp-json";
import { checkUser } from "../features/cloudstorage/user";
import { loadProjectList, loadUserData } from "../core/code/loader";

export function DataView() {
  //const [cloudUser] = store.useState(CLOUD_USER);
  //const [cloudState] = store.useState(CLOUD_STATE);
  //const [cloudProjectList] = store.useState(CLOUD_PROJECT_LIST);
  const [editorState] = store.useState(EDITOR_VIEW_NAME);
  const [cloudDataList, setCloudDataList] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);

  if (!getDomainCfg().viewSettings.features.permittedDataViewUser || !getDomainCfg().viewSettings.debug) {
    return <p>NOT ALLOWED</p>;
  }

  if (dataLoaded === false) {
    console.log('check user data');
    loadDataList();    
    setDataLoaded(true);
  }

  async function loadDataList() {
    //await checkUser(false);
    await loadProjectList();
    await loadUserData(false);
    const dataList = await listData();
    console.log('list cloud data', dataList)
    setCloudDataList(dataList);
  }

  const user = JSON.stringify(getCloudUser());
  console.log('view current user', getCloudUser());  
  console.log('view cloud data', getCloudData())
  console.log('view project list', getCloudProjectList())
  console.log('view cloud data list', cloudDataList)
  //const editorData = JSON.stringify(editorState);
  const data = <>
    <p>SHOW DATA</p>
    <p>User: <textarea cols={125} rows={10}>{user}</textarea></p>    
    <p>More details in console</p>
  </>;
  return <div className="container-fluid">
    <div className="row">
      <div className="col-1">
        MENU
        <button className="btn btn-primary" onClick={loadDataList}>LOAD DATA</button>
      </div>
      <div className="col-11">
        { data }
      </div>
    </div>
  </div>;
}